<script lang="ts">var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
import CardBase from '../../../common/CardBase.svelte';
import { CardsDataSourceRegistration } from '../../../common/CardsDataSourceRegistration';
import { YinzCamCardsServiceElement } from 'yinzcam-cards';
import { Readable } from 'svelte/store';
import { CardsTabContext, CardsTabContextKey } from '../../../common/context';
import { getContext, onMount } from "svelte";
import TextInput from "../TextInput/TextInput.svelte";
import _ from "lodash";
import { JanusSignonManager, JanusSignonManagerToken } from "../../../../../js/sso";
import { getToken } from 'inversify-token';
import ROOT from '../../../../../inversify.config';
export let element;
export let sources;
export let sourceStore;
const tabContext = getContext(CardsTabContextKey);
const signonManager = getToken(ROOT, JanusSignonManagerToken);
$: mergedParams = (_a = tabContext === null || tabContext === void 0 ? void 0 : tabContext.mergedParamsComp) === null || _a === void 0 ? void 0 : _a.store;
$: type = ((_b = element === null || element === void 0 ? void 0 : element.data) === null || _b === void 0 ? void 0 : _b.type) || 'text';
$: label = ((_c = element === null || element === void 0 ? void 0 : element.data) === null || _c === void 0 ? void 0 : _c.label) || '';
$: required = ((_d = element === null || element === void 0 ? void 0 : element.data) === null || _d === void 0 ? void 0 : _d.required) || undefined;
$: requiredKey = (_e = element === null || element === void 0 ? void 0 : element.data) === null || _e === void 0 ? void 0 : _e.requiredKey;
$: mask = ((_f = element === null || element === void 0 ? void 0 : element.data) === null || _f === void 0 ? void 0 : _f.mask) || undefined;
$: maskChar = ((_g = element === null || element === void 0 ? void 0 : element.data) === null || _g === void 0 ? void 0 : _g.maskChar) || 'X';
$: numericOnly = ((_h = element === null || element === void 0 ? void 0 : element.data) === null || _h === void 0 ? void 0 : _h.numericOnly) || false;
$: alphaNumericOnly = ((_j = element === null || element === void 0 ? void 0 : element.data) === null || _j === void 0 ? void 0 : _j.alphaNumericOnly) || false;
$: alphaOnly = ((_k = element === null || element === void 0 ? void 0 : element.data) === null || _k === void 0 ? void 0 : _k.alphaOnly) || false;
$: customPattern = ((_l = element === null || element === void 0 ? void 0 : element.data) === null || _l === void 0 ? void 0 : _l.customPattern) || undefined;
$: valueKey = ((_m = element === null || element === void 0 ? void 0 : element.data) === null || _m === void 0 ? void 0 : _m.valueKey) || undefined;
$: profileSegment = ((_o = element === null || element === void 0 ? void 0 : element.data) === null || _o === void 0 ? void 0 : _o.profileSegment) || undefined;
$: profileField = ((_p = element === null || element === void 0 ? void 0 : element.data) === null || _p === void 0 ? void 0 : _p.profileField) || undefined;
$: defaultValue = ((_q = element === null || element === void 0 ? void 0 : element.data) === null || _q === void 0 ? void 0 : _q.defaultValue) || '';
$: isRequiredFromKey = requiredKey ? ($mergedParams || {})[requiredKey] : false;
$: isRequired = !_.isNil(required) ? required : isRequiredFromKey;
$: placeholder = isRequired ? `${label}*` : label;
let value = defaultValue;
onMount(() => __awaiter(void 0, void 0, void 0, function* () {
    if (!profileField) {
        return;
    }
    const profileData = yield signonManager.getUserProfileSegment(profileSegment);
    const data = (profileData === null || profileData === void 0 ? void 0 : profileData.data) || {};
    value = _.isNil(data[profileField]) ? defaultValue : data[profileField];
}));
let pattern = undefined;
let onKeyDown = (e) => { return true; };
$: if (customPattern) {
    pattern = customPattern;
}
else if (numericOnly) {
    pattern = '\\d*';
    onKeyDown = (e) => { if (!/[0-9]/i.test(e.key)) {
        e.preventDefault();
        return false;
    }
    else
        return true; };
}
else if (alphaNumericOnly) {
    pattern = '[a-zA-Z0-9]*';
    onKeyDown = (e) => { if (!/[a-z0-9]/i.test(e.key)) {
        e.preventDefault();
        return false;
    }
    else
        return true; };
}
else if (alphaOnly) {
    pattern = '[a-zA-Z]*';
    onKeyDown = (e) => { if (!/[a-z]/i.test(e.key)) {
        e.preventDefault();
        return false;
    }
    else
        return true; };
}
const handleChange = ({ target, detail }) => {
    if (mask) {
        value = detail.inputState.maskedValue;
    }
    else {
        value = target.value;
    }
    console.log(label + ': ', value);
};
// Update tab context on all value changes
$: (function (_valueKey, _value) {
    if (_valueKey && !_.isNil(_value)) {
        tabContext.setParam(_valueKey, _value);
    }
    else {
        tabContext.setParam(_valueKey, undefined);
    }
})(valueKey, value);
</script>

<CardBase {element}>
    <div class="generic-text-input-field-wrapper">
        <TextInput {type} {placeholder} {value} {mask} {maskChar} {pattern} {onKeyDown} onChange={handleChange} />
    </div>
</CardBase>

<style>.generic-text-input-field-wrapper {
  gap: 4px;
  width: 100%;
  display: flex;
  flex-direction: column;
}</style>